module.exports = __webpack_public_path__ + "img/scene2-4.8d7dcd17.png";